/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Twda_ConfirmInputs */



/**
* | output |
* | --- |
* | "Trigger a TWDA deck import now?" |
*
* @param {Admin_Sync_Twda_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_twda_confirm = /** @type {((inputs?: Admin_Sync_Twda_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Twda_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déclencher une importation des decks TWDA maintenant ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Activar una importación de mazos de la TWDA ahora?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Disparar uma importação de decks da TWDA agora?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avviare un'importazione dei deck della TWDA ora?")
	return /** @type {LocalizedString} */ ("Trigger a TWDA deck import now?")
});